import { call, put, takeEvery } from "redux-saga/effects";

import {
  CASOSDETALLES_LIST,
  CASOSDETALLES_LISTA,
  CASOSDETALLES_FILTER,
  CASOSDETALLES_CREATE,
  CASOSDETALLES_UPDATE,
  CASOSDETALLES_READ,


} from "./actionTypes";

import {
  
  casosDetallesListSuccess,
  casosDetallesCreateSuccess,
  casosDetallesUpdateSuccess,
  casosDetallesRequestFailed,
 
  CasosDetallesReadSuccess
 
} from "./actions";

import {
  getCasosDetallesList,
  getCasosDetallesLista,
  getCasosDetallesFilter,
  postCasosDetallesCreate,
  patchCasosDetallesUpdate,
  getCasosDetallesRead
} from "../../helpers/backend";



function*casosDetallesListSaga() {
  console.log("Trayendo lista de casosDetalles...");
  try {
    const response = yield call(getCasosDetallesList);
    if (response.status === 200) {
      yield put(casosDetallesListSuccess(response.data));
    } else {
      yield put(casosDetallesRequestFailed(response.data));
    }
  } catch (error) {
    yield put(casosDetallesRequestFailed(error.response.data));
  }
}

function*casosDetallesListaSaga() {
  console.log("Trayendo lista de casosDetalles...");
  try {
    const response = yield call(getCasosDetallesLista);
    if (response.status === 200) {
      yield put(casosDetallesListSuccess(response.data));
    } else {
      yield put(casosDetallesRequestFailed(response.data));
    }
  } catch (error) {
    yield put(casosDetallesRequestFailed(error.response.data));
  }
}

function*casosDetallesCreateSaga({ payload:casosDetalles }) {
  console.log("Creando nuevo casosDetalles...");
  try {
    const response = yield call(postCasosDetallesCreate,casosDetalles);
    if (response.status === 201) {
      yield put(casosDetallesCreateSuccess(response.data));
    } else {
      yield put(casosDetallesRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(casosDetallesRequestFailed(error.response.data));
  }
}

function*casosDetallesFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getCasosDetallesFilter, { changeUrl });
    if (response.status === 200) {
      yield put(casosDetallesListSuccess(response.data));
    } else {
      yield put(casosDetallesRequestFailed(response.data));
    }
  } catch (error) {
    yield put(casosDetallesRequestFailed(error.response.data));
  }
}

function*casosDetallesUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos de la herramienta...");
  
  try {
    const response = yield call(patchCasosDetallesUpdate,  id , data);
    if (response.status === 200) {
      yield put(casosDetallesUpdateSuccess(response.data));
      
      
    } else {
      yield put(casosDetallesRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(casosDetallesRequestFailed(error.response.data));
    
  }
}

function* CasosDetallesReadSaga({ payload: { id } }) {
  console.log("Probando...");
  try {
    const response = yield call(getCasosDetallesRead, id);

    if (response.status === 200) {
       yield put(CasosDetallesReadSuccess(response.data));
      } else {
        yield put(casosDetallesRequestFailed(response.data));
      }
    } catch (error) {
      yield put(casosDetallesRequestFailed(error.response.data));
    }

}

export default function*casosDetallesSaga() {
  yield takeEvery(CASOSDETALLES_LIST,casosDetallesListSaga);
  yield takeEvery(CASOSDETALLES_LISTA,casosDetallesListaSaga);
  yield takeEvery(CASOSDETALLES_FILTER,casosDetallesFilterSaga);
  yield takeEvery(CASOSDETALLES_CREATE,casosDetallesCreateSaga);
  yield takeEvery(CASOSDETALLES_UPDATE,casosDetallesUpdateSaga);
  yield takeEvery(CASOSDETALLES_READ,CasosDetallesReadSaga);
}
